import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { BlockTypeIconConfig } from '../../../models/blocks/block-type-config.constants';
import { ListBlockRenderRow } from '../list-blocks/list-block-render-row.model';

@Component({
  selector: 'empathy-list-block-item',
  templateUrl: 'list-block-item.component.html',
  styleUrls: ['./list-block-item.component.scss', './_list-block-item-theme.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListBlockItemComponent {
  active = input<boolean>(false);
  row = input.required<ListBlockRenderRow>();

  activate = output<string>();

  blockTypeIconConfig = BlockTypeIconConfig;
}
